import React from "react";
import { Link } from "react-router-dom";
import { APP_NO_IMG } from "../../const/root";
import { BasketItem } from "./BasketItem";
import { AvailableOrNot } from "../../pages/cardSmallComponents/AvailableOrNot";
import { IsMedicalIsNoveltyIsSale } from "../../pages/cardSmallComponents/IsMedicalisNoveltyIsSale";
import { IsSellout } from "./ComponentsGoodsItem/IsSellout";
import { ImgProduct } from "./ComponentsGoodsItem/ImgProduct";
import { ProductName } from "./ComponentsGoodsItem/ProductName";
import { PriceProduct } from "./ComponentsGoodsItem/PriceProduct";
import { PriceProductMobile } from "./ComponentsGoodsItem/PriceProductMobile";
import { observer } from "mobx-react";
import { withStore } from "../../hocs";
import Icon from '@mdi/react';
import { mdiTicketPercent } from '@mdi/js';


interface Props {
  item: {};
  siteId: number;
  includeUserLoyaltyProgram: boolean;
}

// @ts-ignore
@withStore
@observer
export class GoodsItem extends React.Component<Props, {}> {
  // @ts-ignore
  addDefaultSrc = (ev) => {
    ev.target.src = APP_NO_IMG;
  };

  render() {
    let item: any = this.props.item;
    const siteId = this.props.siteId;
    const includeUserLoyaltyProgram = this.props.includeUserLoyaltyProgram;
    let price = item.price?.final_price;

    let priceOld = item.price?.base_price;
    let discount_minimum_amount = item.price?.discount_minimum_amount

    // @ts-ignore
    const { store } = this.props;
    const { user } = store?.mainStore;

    if (user?.type === "clientGuest" || !user) {
        price=priceOld;
    }

    let isPriceOld = price !== priceOld;
    const img = item.img;
    let src = img.small.length ? img.small[0] : APP_NO_IMG;
    let isNovelty = false;
    let isSellout = false;
    let isMedical = false;
    let isSale = parseFloat(item.price?.discountmarketing);
    let showNds = true;

    if (siteId === 3) {
      showNds = false;
      if (item?.propsNoFilter?.vat) {
        price = (
          (price / 100) *
          (100 + parseInt(item?.propsNoFilter?.vat))
        ).toFixed(2);
        priceOld = (
          (priceOld / 100) *
          (100 + parseInt(item?.propsNoFilter?.vat))
        ).toFixed(2);
      }
    }

    if (isPriceOld) {
      isSale = -(((priceOld - price) / priceOld) * 100).toFixed(2);
    }

    if (item?.props?.isNovelty) {
      isNovelty = true;
    }
    if (item?.props?.isSellout) {
      isSellout = true;
    }
    if (item?.props?.isMedical) {
      isMedical = true;
    }

    let Width = window.innerWidth;
    let mobileWidth = 483;

    return (
      <>
        <div
          className="goods-item"
          key={"good-" + item.code}
          style={Width < mobileWidth ? { height: 'auto', paddingTop: 30, paddingBottom: 20 } : {}}
        >
          {discount_minimum_amount > 0 ? <div style={{position: "absolute", marginTop: 130}}>
            <Icon path={mdiTicketPercent} color={'#ff5d55'} size={2} />
          </div> : null}


          <IsSellout isSellout={isSellout} />

          {Width < mobileWidth ? null : (
            <>
              {item.props.isIncludeLoyaltyProgram &&
              includeUserLoyaltyProgram ? (
                <div className="tooltip">
                  <div
                    style={{
                      backgroundImage: `url("/img/ico/bonus1.png")`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "absolute",
                      // zIndex: 99999,
                      position: "absolute",
                      height: 100,
                      width: 100,
                      left: "-7%",
                    }}
                  >
                    <span className="tooltiptext " style={{ top: 10 }}>
                      Товар можно частично оплатить бонусами
                    </span>
                    <span
                      className="count-text-basket"
                      style={{ opacity: 0, marginTop: -15 }}
                    >
                      0
                    </span>
                  </div>
                </div>
              ) : null}


              <div className="goods-item-img">
                <div>
                  <Link to={"/card/" + item.code}>
                    <img
                      className="fix-img"
                      src={src}
                      onError={this.addDefaultSrc}
                      alt="good.png"
                    />
                  </Link>
                </div>
              </div>

              <div className="goods-item-sticker">
                <IsMedicalIsNoveltyIsSale
                  isSale={isSale}
                  isNovelty={isNovelty}
                  isMedical={isMedical}
                />
              </div>

              <PriceProduct
                price={price}
                isPriceOld={isPriceOld}
                showNds={showNds}
                priceOld={priceOld}
              />

              <Link to={"/card/" + item.code}>
                <div className="goods-content-text">
                  <ProductName item={item} />
                  <AvailableOrNot final_price={price} />
                </div>
              </Link>
            </>
          )}

          <div
            className="goods-item-img"
            style={
              Width < mobileWidth
                ? { paddingTop: 20, height: 'auto' }
                : { display: "none" }
            }
          >
            {item.props.isIncludeLoyaltyProgram ? (
              <div className="tooltip">
                <div
                  style={{
                    backgroundImage: `url("/img/ico/bonus3.png")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "absolute",
                    // zIndex: 99999,
                    position: "absolute",
                    height: 100,
                    width: 100,
                    top: -99,
                  }}
                >
                  <span className="tooltiptext " style={{ top: 10 }}>
                    Товар можно частично оплатить бонусами
                  </span>
                  <span
                    className="count-text-basket"
                    style={{ opacity: 0, marginTop: -15 }}
                  >
                    0
                  </span>
                </div>
              </div>
            ) : null}

            <Link to={"/card/" + item.code}>
              {" "}
              <ImgProduct src={src} />
            </Link>
            <div
              className="goods-content-text"
              style={
                Width < mobileWidth ? { marginTop: -20 } : { display: "none" }
              }
            >
              <Link to={"/card/" + item.code}>
                {" "}
                <ProductName item={item} />
                <AvailableOrNot final_price={price} />

                <PriceProductMobile
                  price={price}
                  isPriceOld={isPriceOld}
                  priceOld={priceOld}
                  isSale={isSale}
                  isNovelty={isNovelty}
                  isMedical={isMedical}
                />
              </Link>


              <div>
                <BasketItem item={item} isDetail={false} />
              </div>
            </div>
          </div>
          {/*</Link>*/}

          {Width < mobileWidth ? null : (
            <BasketItem item={item} isDetail={false} />
          )}
        </div>
      </>
    );
  }
}
